import { useEffect, useState } from 'react';
import { useStepsStore } from '../stores/StepsStore';
import PostcodeLookupComponent from './fragments/PostcodeLookupComponent';
import Select from 'react-select';
import { relationships } from '../services/Relashionships';

const Step_BillingDetails = (props: { onpenVATModal: () => void; }) => {

  const [endUserFirstName, setEndUserFirstName] = useState<string>('');
  const [endUserTelephone, setEndUserTelephone] = useState<string>('');
  const [endUserlastName, setEndUserlastName] = useState<string>('');
  const [endUserZip, setEndUserZip] = useState<string>('');

  const [tooltip, setTooltip] = useState<{ text: string; x: string; y: string; visible: boolean; }>({ text: "", x: '0', y: '0', visible: false });

  const { error, setFormValue, gclErrors, newCustomerForm, setCarelineServiceStartsAt, carelineServiceStartsAt } = useStepsStore();
  const handleIamServiceUserChange = (event: React.ChangeEvent<HTMLInputElement>) => { setIamServiceUser(event.target.checked); };
  const [differentBillingAddress, setDifferentBillingAddress] = useState(false);
  const handleDifferentBillingAddressChange = (event: React.ChangeEvent<HTMLInputElement>) => { setDifferentBillingAddress(event.target.checked); };
  const [iamServiceUser, setIamServiceUser] = useState(false);
  const [isAGift, setIsAGift] = useState(false);
  const handleIsAGiftChange = (event: React.ChangeEvent<HTMLInputElement>) => { setIsAGift(event.target.checked); };
  const [enableAddress, setEnableAddress] = useState(false);
  const [email, setEmail] = useState<string>('');
  const [emailClass, setEmailClass] = useState<string>('');
  const [line1, setLine1] = useState<string>('');
  const [line2, setLine2] = useState<string>('');
  const [county, setCounty] = useState<string>('');
  const [phone, setPhone] = useState<string>('');
  const [city, setCity] = useState<string>('');
  const [zip, setZip] = useState<string>('');
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [selectedRelashionship, setSelectedRelashionship] = useState<{ value: string; label: string; } | null>(null);
  const [otherRelashionship, setOtherRelashionship] = useState<string>('');
  const [vatExempt, setVatExempt] = useState(false);
  const handleVatExempt = (event: React.ChangeEvent<HTMLInputElement>) => { setVatExempt(event.target.checked); };

  const [acceptMarketing, setAcceptMarketing] = useState(false);
  const handleAcceptMarketingChange = (event: React.ChangeEvent<HTMLInputElement>) => { setAcceptMarketing(event.target.checked); };

  const setEmailWrapper = (value: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = regex.test(value);
    if (!isValid) {
      setEmailClass('error-required');
    } else {
      setEmailClass('');
    }
    setEmail(value);
  }

  const setAddress = (address: { line_1: string; line_2: string; line_3: string; post_town: string; postcode: string; postal_county: string; }) => {
    setLine1(address.line_1);
    setLine2(address.line_2);
    setCounty(address.postal_county);
    setCity(address.post_town);
    setZip(address.postcode);
  };

  const showTooltip = (event: React.MouseEvent<HTMLLabelElement, MouseEvent>, top: number, left: number, txt: string) => {

    setTooltip({
      text: txt,
      x: `${left}px`,
      y: `${top}px`,
      visible: true
    });
  };

  const closeTooltip = (event: React.MouseEvent<HTMLLabelElement, MouseEvent>) => {
    setTooltip((t) => ({ ...t, visible: false }));
  };

  useEffect(() => {
    if (gclErrors.includes('email')) {
      setEmailClass('error-required');
    }
  }, [gclErrors]);

  useEffect(() => {
    if (newCustomerForm) {
      setFirstName(newCustomerForm.billing_info.first_name);
      setLastName(newCustomerForm.billing_info.last_name);
      setLine1(newCustomerForm?.billing_info.address.line1 ?? '');
      setLine2(newCustomerForm?.billing_info.address.line2 ?? '');
      setCounty(newCustomerForm?.billing_info.address.county ?? '');
      setCity(newCustomerForm?.billing_info.address.city ?? '');
      setZip(newCustomerForm?.billing_info.address.zip ?? '');
      setPhone(newCustomerForm?.billing_info.phone ?? '');
      setEmailWrapper(newCustomerForm?.billing_info.email ?? '');
      setIamServiceUser(newCustomerForm.relationship ? false : true);
      setVatExempt(newCustomerForm.vat_exempt);
      setAcceptMarketing(newCustomerForm.accept_marketing.billing_user);

      setEndUserFirstName(newCustomerForm.end_user?.first_name || '');
      setEndUserlastName(newCustomerForm.end_user?.last_name || '');
      setEndUserTelephone(newCustomerForm.end_user?.telephone || '');
      setEndUserZip(newCustomerForm.end_user?.zip || '');
      if (carelineServiceStartsAt) {
        setIsAGift(true);
      }
      if (!newCustomerForm.iamserviceuser && newCustomerForm.relationship) {
        setSelectedRelashionship({ value: newCustomerForm.relationship, label: newCustomerForm.relationship });
      }
      if (!newCustomerForm.iamserviceuser && newCustomerForm.other_relationship) {
        setOtherRelashionship(newCustomerForm.other_relationship);
      }
    }
  }, [newCustomerForm]);

  useEffect(() => {
    setFormValue('vat_exempt', [], vatExempt);
  }, [vatExempt]);

  useEffect(() => {
    setFormValue('accept_marketing', ['billing_user'], acceptMarketing);
  }, [acceptMarketing]);


  useEffect(() => {
    setFormValue('end_user', [], { first_name: endUserFirstName ?? '', last_name: endUserlastName ?? '', zip: endUserZip ?? '', telephone: endUserTelephone ?? '' });
    setFormValue('billing_info', ['first_name'], firstName);
    setFormValue('billing_info', ['last_name'], lastName);
    setFormValue('billing_info', ['email'], email);
    setFormValue('billing_info', ['phone'], phone);
    setFormValue('billing_info', ['address', 'line1'], line1);
    setFormValue('billing_info', ['address', 'line2'], line2);
    setFormValue('billing_info', ['address', 'city'], city);
    setFormValue('billing_info', ['address', 'county'], county);
    setFormValue('billing_info', ['address', 'zip'], zip);
    setFormValue('relationship', [], selectedRelashionship?.value ?? '');
    setFormValue('other_relationship', [], otherRelashionship ?? '');
    setFormValue('iamserviceuser', [], iamServiceUser);
    setCarelineServiceStartsAt(isAGift ? '2025-12-25' : null);
  }, [isAGift, endUserFirstName, endUserlastName, endUserTelephone, endUserZip, firstName, lastName, line1, line2, city, county, zip, email, phone, selectedRelashionship, otherRelashionship, iamServiceUser]);

  // Sort code 200000 Account 55779911
  return (
    <div className="simple-form">
      <h2 className='ncf-title'>Your Details</h2>
      <span className='ncf-subtitle'>Tick the following box if this applies to you.</span>

      <div className='form-line checkbox-and-input negative-margin'>
        <div className='input-group'>
          <label className="custom-checkbox">
            <input type="checkbox"
              checked={iamServiceUser}
              onChange={handleIamServiceUserChange}
            />
            <span></span>
            I am the alarm service user and I will pay for the service.
          </label>
        </div>
      </div>
      <div style={ { display: 'none' } } className='form-line checkbox-and-input'>
        <div className='input-group'>
          <label className="custom-checkbox">
            <input type="checkbox"
              checked={isAGift}
              onChange={handleIsAGiftChange}
            />
            <span></span>
            This purchase is a Christmas gift. By ticking this box, your 1-month trial service will begin on 25 December 2025.
          </label>
        </div>
      </div>
      {!iamServiceUser ?
        <div className='form-line relationship-line'>
          <p className='no-margin-bottom'>If you are not the alarm user please select your relationship with them.</p>
          <div className='medical-conditions-wrap input-group left'>
            <Select
              options={relationships.map(t => ({ value: t, label: t }))}
              value={selectedRelashionship}
              className={gclErrors.length && gclErrors.includes('relationship') ? ' input-ncf error-required' : 'input-ncf'}
              onChange={(selectedOption) => { setSelectedRelashionship(selectedOption); }}
            />
            <label className='placeholder'>Your relationship with alarm user*</label>
          </div>
          {selectedRelashionship?.value === 'Other' ?
            <div className='input-group right'>
              <input
                type="text"
                value={otherRelashionship}
                className={gclErrors.length && gclErrors.includes('relashionship') ? 'input-ncf error-required' : 'input-ncf'}
                onChange={(e) => setOtherRelashionship(e.target.value)}
              />
              <label className='placeholder'>Other Relationship*</label>
            </div>
            : ''}
        </div> : ''}
      <div className="border-bottom margin-bottom margin-top">
        <div className='margin-bottom'>
          <label className='ncf-title'>Alarm User Details</label>
        </div>
        <div className='form-line'>
          <div className='input-group left'>
            <input
              type="text"
              value={endUserFirstName}
              className='input-ncf'
              onChange={(e) => setEndUserFirstName(e.target.value)}
            />
            <label className='placeholder'>First Name*</label>
          </div>
          <div className='input-group right'>
            <input
              type="text"
              className='input-ncf'
              value={endUserlastName}
              onChange={(e) => setEndUserlastName(e.target.value)}
            />
            <label className='placeholder'>Last name*</label>
          </div>
        </div>
        <div className='form-line margin-top'>
          <div className='input-group left'>
            <input
              type="text"
              value={endUserZip}
              className='input-ncf'
              onChange={(e) => setEndUserZip((e.target.value ?? '').toUpperCase())}
            />
            <label className='placeholder'>Postcode*</label>
          </div>
        </div>
        <div className='form-line margin-top'>
          <div className='input-group left'>
            <div className="input-wrapper prefix-input-wrapper">
              <span className="bit-prefix">+44</span>
              <input
                type="text"
                value={endUserTelephone}
                className='input-ncf small-prefix'
                onChange={(e) => setEndUserTelephone(e.target.value)}
              />
            </div>
            <label className='placeholder'>Telephone*</label>
          </div>
        </div>
      </div>
      <div className="border-bottom margin-bottom">
        <div className='margin-bottom'>
          <label className='ncf-title'>Billing Details</label>
        </div>
        <div className='form-line'>
          <div className='input-group left'>
            <input
              type="text"
              className={gclErrors.includes('first_name') ? 'input-ncf error-required' : 'input-ncf'}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
            <label className='placeholder'>First Name*</label>
          </div>
          <div className='input-group right'>
            <input
              type="text"
              className={gclErrors.includes('last_name') ? 'error-required input-ncf' : 'input-ncf'}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)} required
            />
            <label className='placeholder'>Last Name*</label>
          </div>
        </div>
        <div className='form-line'>
          <div className='input-group left'>
            <input
              type="text"
              value={email}
              className={emailClass}
              onChange={(e) => setEmailWrapper(e.target.value)}
            />
            <label className='placeholder events-yes' style={{ cursor: "pointer" }} onMouseOver={(event) => showTooltip(event, -7, 65, "An Email is essential!")} onMouseLeave={(event) => closeTooltip(event)}>
              Email <img width={'13px'} height={'13px'} style={{ top: "1px", position: "relative" }} src={(window as any).gcl_exclamation} />
              {tooltip.visible && (
                <div style={{
                  position: "absolute", top: tooltip.y, left: tooltip.x,
                  background: "#005F70", color: "white", padding: "5px 7px", borderRadius: "6px",
                  fontSize: "1.2rem", whiteSpace: "nowrap", pointerEvents: "none", zIndex: 9999
                }} >
                  {tooltip.text}
                </div>)}
            </label>
          </div>
          <div className='input-group right'>
            <div className="input-wrapper prefix-input-wrapper">
              <span className="bit-prefix">+44</span>
              <input
                type="text"
                value={phone}
                className={gclErrors.length && gclErrors.includes('phone') ? 'input-ncf error-required small-prefix' : 'input-ncf small-prefix'}
                onChange={(e) => setPhone(e.target.value)}
              />

            </div>
            <label className='placeholder'>Phone*</label>
          </div>
        </div>
        <div className='form-line checkbox-and-input'>
          <div className='input-group left'>
            <label className="custom-checkbox">
              <input type="checkbox"
                checked={differentBillingAddress}
                onChange={handleDifferentBillingAddressChange}
              />
              <span></span>
            Add a different billing address
            </label>
          </div>
        </div>
        {differentBillingAddress ? <div style={{ margin: '20px 0' }}>
          <PostcodeLookupComponent onAddressSelected={(address) => setAddress(address)} onNoResults={() => { setEnableAddress(true) }} onResults={() => { setEnableAddress(false) }} />
        </div> : ''}
        <div className='form-line'>
          <div className='input-group left'>
            <input
              type="text"
              className={gclErrors.includes('line1') ? 'input-ncf error-required' : 'input-ncf'}
              value={line1}
              onChange={(e) => setLine1(e.target.value)}
              disabled={differentBillingAddress === false || !enableAddress}
            />
            <label className='placeholder'>Line 1*</label>
          </div>
          <div className='input-group right'>
            <input
              type="text"
              value={line2}
              onChange={(e) => setLine2(e.target.value)}
              disabled={differentBillingAddress === false || !enableAddress}
              className='input-ncf'
            />
            <label className='placeholder'>Line 2</label>
          </div>
        </div>
        <div className='form-line'>
          <div className='input-group left'>
            <input
              type="text"
              className={gclErrors.includes('city') ? 'input-ncf error-required' : 'input-ncf'}
              value={city}
              onChange={(e) => setCity(e.target.value)}
              disabled={differentBillingAddress === false || !enableAddress}
            />
            <label className='placeholder'>City*</label>
          </div>
          <div className='input-group right'>
            <input
              type="text"
              className={gclErrors.includes('county') ? 'input-ncf error-required' : 'input-ncf'}
              value={county}
              onChange={(e) => setCounty(e.target.value)}
              disabled={differentBillingAddress === false || !enableAddress}
            />
            <label className='placeholder'>County*</label>
          </div>
        </div>
        <div className='form-line'>
          <div className='input-group left'>
            <input
              type="text"
              value={zip}
              className={gclErrors.includes('zip') ? 'error-required input-ncf' : 'input-ncf'}
              onChange={(e) => setZip(e.target.value)}
              disabled={differentBillingAddress === false || !enableAddress}
            />
            <label className='placeholder'>Postcode*</label>
          </div>
          <div className='input-group right'>
            <input
              type="text"
              className='input-ncf'
              value={'United Kingdom'}
              disabled
            />
            <label className='placeholder'>Country*</label>
          </div>
        </div>
      </div>
      <div className='input-group'>
        <label className="custom-checkbox">
          <input type="checkbox"
            id="other-medical-conditions"
            checked={vatExempt}
            onChange={handleVatExempt}
          />
          <span></span>
          I declare that I or the Alarm User qualify for VAT Relief.
          <button style={{ border: '0px' }} className='no-style' onClick={props.onpenVATModal}><img width={'15px'} height={'15px'} src={(window as any).gcl_exclamation} /></button>
        </label>
      </div>
      <div className='form-line no-margin'>
        <div className='input-group left'>
          <label className="custom-checkbox">
            <input type="checkbox"
              checked={acceptMarketing}
              onChange={handleAcceptMarketingChange}
            />
            <span></span>
            Contact me by email with life saving information about Careline365's service and products.
          </label>
        </div>
      </div>
      {error !== '' ? <div className="error">{error}</div> : ''}
    </div>
  );
};

export default Step_BillingDetails;